import * as z from 'zod'

import { Language, SupportedMarketKey, supportedMarketSchema } from '@nxt-insurance/constants'

import { locales } from '@/constants'

export const languageSchema = z.nativeEnum(Language)

export const getLocaleParts = (locale = ''): [Language, SupportedMarketKey] => {
  const [unparsedLang, unparsedMarket] =
    locale === 'default' ? [Language.En, SupportedMarketKey.De] : locale.split('-')
  return [languageSchema.parse(unparsedLang), supportedMarketSchema.parse(unparsedMarket)]
}

export const getLanguagesForMarket = (allLocales: string[], market: SupportedMarketKey) => {
  const marketLocales = allLocales.filter((locale) => {
    return locale.endsWith(`-${market}`)
  })
  return marketLocales.map((locale) => getLocaleParts(locale)[0])
}

export const getCorrectLocale = (
  localeFromBrowser: string,
  country?: string,
  localeFromCountry?: string
) => {
  const [langBrowser, marketBrowser] = localeFromBrowser.split('-')
  if (!country && locales.includes(localeFromBrowser)) {
    return localeFromBrowser
  } else if (marketBrowser === country && locales.includes(localeFromBrowser)) {
    return localeFromBrowser
  } else if (marketBrowser === country) {
    return localeFromCountry ?? 'en-de'
  } else if (marketBrowser !== localeFromCountry && locales.includes(`${langBrowser}-${country}`)) {
    return `${langBrowser}-${country}`
  } else if (country) {
    return localeFromCountry
  }
  return 'en-de'
}
export const getCorrectLocaleForMarket = (
  currentLocale: string,
  market: SupportedMarketKey
): `${Language}-${SupportedMarketKey}` => {
  const [currentLang, currentMarket] = getLocaleParts(currentLocale)
  if (locales.includes(currentLocale) && market === currentMarket) {
    // type casting is fine, we validate the locale with `getLocaleParts`
    return currentLocale as `${Language}-${SupportedMarketKey}`
  }
  const localeWithMarket = `${currentLang}-${market}` as const
  if (locales.includes(localeWithMarket)) {
    return localeWithMarket
  }
  const locale = locales.find((l) => l.split('-')[1] === (market as string))
  return locale as `${Language}-${SupportedMarketKey}`
}
